import { Link, useNavigate, useLocation } from "react-router-dom";
import { NavDropdown, NAV_MENUS } from "./NavDropdown";
import { useAuth } from "../context/AuthContext";
import { Droplets, LogOut, LayoutDashboard, ShieldCheck } from "lucide-react";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const doLogout = () => { logout(); navigate("/"); };

  const navLink = (to, label) => (
    <Link
      to={to}
      data-testid={`nav-${label.toLowerCase().replace(/\s/g, "-")}`}
      className={`overline transition-colors hover:text-white ${pathname === to ? "text-white" : "text-muted-foreground"}`}
    >
      {label}
    </Link>
  );

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-black/70 backdrop-blur-xl backdrop-saturate-150">
      <div className="mx-auto max-w-7xl px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <div className="w-9 h-9 bg-volt flex items-center justify-center">
            <Droplets className="w-5 h-5 text-white" />
          </div>
          <span className="font-head font-extrabold text-xl tracking-tight uppercase">Earlwood</span>
        </Link>

        <nav className="flex items-center gap-6">
          <div className="hidden md:flex items-center gap-6">
            {NAV_MENUS.map((m) => <NavDropdown key={m.label} {...m} />)}
          </div>
          <div className="md:hidden">
            <NavDropdown label="Menu" items={[...NAV_MENUS.flatMap((m) => m.items.map((i) => ({ ...i, label: `${m.label} — ${i.label}` }))), { to: "/pricing", label: "All Prices" }]} />
          </div>
          <span className="hidden md:inline">{navLink("/pricing", "Pricing")}</span>
          {!user && <span className="hidden sm:inline">{navLink("/wash", "Get A Wash")}</span>}
          {user && user.role === "customer" && navLink("/dashboard", "Dashboard")}
          {user && user.role === "customer" && navLink("/wash", "Get A Wash")}
          {user && user.role === "admin" && navLink("/admin", "Admin")}

          {!user ? (
            <div className="flex items-center gap-3">
              <Link to="/login" data-testid="nav-login-btn" className="overline text-muted-foreground hover:text-white transition-colors">Login</Link>
              <Link to="/register" data-testid="nav-register-btn" className="overline bg-volt text-white px-4 py-2 hover:bg-blue-600 transition-colors">Join Now</Link>
            </div>
          ) : (
            <div className="flex items-center gap-4">
              <span className="hidden sm:flex items-center gap-2 text-sm text-muted-foreground">
                {user.role === "admin" ? <ShieldCheck className="w-4 h-4 text-volt" /> : <LayoutDashboard className="w-4 h-4 text-volt" />}
                {user.name}
              </span>
              <button data-testid="nav-logout-btn" onClick={doLogout} className="flex items-center gap-1 overline text-muted-foreground hover:text-white transition-colors">
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
}
